import React, { useEffect } from 'react';
import { AssignmentStatus, ProposedTrip } from 'src/common/types';
import './movements.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getDriverInfo } from 'src/features/profile/store';
import { convertISOTimeToHours } from 'src/helpers/driverEldInfoHelper';

import { Button } from '../../../components/Button/Button';
import {
  acceptMovements,
  rejectMovements,
  setMovementClaimed,
  setMovementRejected,
} from '../store/movementStore';

interface ClaimMovementProps {
  movement: ProposedTrip;
}

export const ProposedMovement: React.FC<ClaimMovementProps> = ({ movement }) => {
  const driverInfo = useSelector(getDriverInfo);
  const dispatch = useDispatch();

  // scroll to the top of the page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleClaim = (movementId: number, editId: number) => {
    dispatch(acceptMovements({ employeeId: driverInfo.employeeId, editIds: [editId] }));
    dispatch(setMovementClaimed({ type: AssignmentStatus.PROPOSED, movementId }));
  };

  const handleRejectMovement = (movementId: number, editId: number) => {
    dispatch(rejectMovements({ employeeId: driverInfo.employeeId, editIds: [editId] }));
    dispatch(setMovementRejected({ type: AssignmentStatus.PROPOSED, movementId }));
  };
  // eslint-disable-next-line new-cap
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <div className="claim-movement-box">
      <div className="claim-movement-text">
        <div>
          {convertISOTimeToHours(movement.movementAssignment.startTimestamp, timezone)} -{' '}
          {convertISOTimeToHours(movement.movementAssignment.endTimestamp, timezone)}
        </div>
        <div>
          {movement.movementAssignment.startLocationString} to{' '}
          {movement.movementAssignment.endLocationString}
        </div>
        <div>{Number(movement.movementAssignment.elapsedOdometer?.toFixed(2))} mi</div>
      </div>
      <div className="claim-movement-buttons">
        {movement.claimed ? (
          <Button title="✔️" style={{ color: 'blue' }} />
        ) : movement.rejected ? (
          <Button title="❌" style={{ color: 'red' }} />
        ) : (
          <>
            <Button
              title={'Reject'}
              className="claim-movement-button"
              onClick={() =>
                handleRejectMovement(movement.movementId, movement.movementAssignment.editId)
              }
            />
            <Button
              title={'Accept'}
              className="claim-movement-button"
              onClick={() => handleClaim(movement.movementId, movement.movementAssignment.editId)}
            />
          </>
        )}
      </div>
    </div>
  );
};
